import styled from 'styled-components';

const Video = styled.video`
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    height: auto;
    display: block;
    position: relative;
    object-fit: contain;
`;

export default Video;
